<template>
  <div class="tw-bg-light-gray tw-min-h-screen">
    <div
      class="tw-relative tw-m-auto tw-mb-12 tw-flex tw-max-w-4xl tw-flex-col tw-px-4"
    >
      <!-- Header -->
      <div class="tw-mb-16 sm:tw-mb-20">
        <div class="tw-flex tw-items-center tw-pt-5">
          <div class="tw-flex tw-items-center">
            <img 
              :src="require('@/assets/logo_Logo.png')" 
              alt="Turtlemeet Logo" 
              class="tw-h-8 tw-mr-2"
            />
            <span class="tw-text-2xl tw-font-medium tw-text-green">Turtlemeet</span>
          </div>
          <v-spacer />
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-items-center">
        <div
          class="tw-mb-8 tw-flex tw-max-w-[30rem] tw-flex-col tw-items-center"
        >
          <div
            id="header"
            class="tw-mb-4 tw-text-center tw-text-3xl tw-font-medium sm:tw-text-4xl lg:tw-text-5xl"
          >
            <h1>Find a time to meet</h1>
          </div>

          <div
            class="tw-text-center tw-text-base tw-text-very-dark-gray sm:tw-text-lg tw-mb-2"
          >
            Coordinate group meetings without the back and forth.
          </div>
          
          <div class="tw-text-center tw-text-sm tw-text-dark-gray tw-mb-8">
            Self-hosted 
            <a 
              href="https://timeful.app" 
              target="_blank" 
              class="tw-text-green hover:tw-underline"
            >Timeful</a> instance
          </div>
        </div>

        <div class="tw-mb-12 tw-space-y-3 tw-flex tw-flex-col tw-items-center">
          <v-btn
            class="tw-rounded-lg tw-bg-green tw-px-12 tw-text-base"
            dark
            @click="newDialog = true"
            large
            :x-large="$vuetify.breakpoint.mdAndUp"
          >
            Create event
          </v-btn>
        </div>

        <!-- How it works -->
        <div class="tw-mt-8 tw-w-full tw-max-w-lg">
          <div
            class="tw-mb-6 tw-text-center tw-text-xl tw-font-medium sm:tw-text-2xl"
          >
            How it works
          </div>
          <div class="tw-flex tw-flex-col tw-gap-4">
            <div
              v-for="(step, i) in howItWorksSteps"
              :key="i"
              class="tw-flex tw-items-center tw-gap-3"
            >
              <div class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-green tw-text-white tw-font-medium tw-flex-shrink-0">
                {{ i + 1 }}
              </div>
              <div class="tw-text-base">{{ step }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />

    <!-- New event dialog -->
    <NewDialog v-model="newDialog" no-tabs />
  </div>
</template>

<script>
import NewDialog from "@/components/NewDialog.vue"
import Footer from "@/components/Footer.vue"

export default {
  name: "Landing",

  metaInfo: {
    title: "Turtlemeet - Find a time to meet",
  },

  components: {
    NewDialog,
    Footer,
  },

  data: () => ({
    newDialog: false,
    howItWorksSteps: [
      "Create an event with possible dates and times",
      "Share the link with your group",
      "Everyone adds their availability",
      "Find the best time that works for all",
    ],
  }),
}
</script>
